import { formatDate, getKmFormat, getPercentaje } from 'libs/functions';
import { useSelector } from 'react-redux';
import { itsItem } from 'redux/state/inventoryState';
import { RootState } from 'redux/store';

const useDetails = () => {
    const items = useSelector((state: RootState) => state.inventory.its);

    const getLabel = (key: string) => {
        const { label } = items.find((item: itsItem) => item.key === key) || {};
        return label || key;
    };

    const isHidden = (key: string) => {
        const { hidden } = items.find((item: itsItem) => item.key === key) || {};
        return !!hidden;
    };

    const isEditable = (key: string) => {
        const { edit } = items.find((item: itsItem) => item.key === key) || {};
        return !!edit;
    };

    const formatValue = (value: string, key: string) => {
        if (!value) {
            return '';
        }
        if (/km/i.test(key)) {
            return getKmFormat(value);
        }
        if (/percent/i.test(key)) {
            return getPercentaje(parseFloat(value), 5);
        }
        if(/ated_at/i.test(key)){
            return formatDate(value);
        }
        return value;
    };

    const isContained = (key: string) => {
        return items.some((item: itsItem) => item.key === key);
    }

    const getNewValues = (key: string) => {
        const { newValues } =  items.find((item: itsItem) => item.key === key) || {}; 
        return !!newValues;

    }

    const getType =  (key: string) => {
        const { type } = items.find((item: itsItem) => item.key === key) || {};
        return type;
    };

     const getSelect = (key: string) => {
        const { selectValues } = items.find((item: itsItem) => item.key === key) || {};
        return selectValues;
    };

    return {
        getNewValues,
        getSelect,
        getType,
        getLabel,
        isHidden,
        isEditable,
        formatValue,
        isContained
    }
}

export default useDetails